// This is generated.  Alter it in blockGroups/listColumns/types/NestedDetail.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { propertyName, children, showAllValues, showStringValues } = hNode;
    //let's find out what the children define....
    let [
      childDefinedSubDataDictionary = {},
      childDefinedPartialTypeDefinition = {},
    ] = children?.reduce(
      ([sdd, ptd], child) => {
        const [_subDataDictionary = {}, _partialTypeDefinition = {}] =
          context.extractFromChild(child, context);
        return [
          merge(sdd, _subDataDictionary),
          moduleRegistration.mergePartialTypeDefinitions(
            ptd,
            _partialTypeDefinition,
          ),
        ];
      },
      [{}, {}],
    ) ?? [{}, {}];

    const isArray =
      showStringValues === true || showAllValues === true ||
      (children || []).some((child) => child.hNodeTypeGroup === 'filter');
    const propertySchema = isArray
      ? Type.Array(
          showStringValues === true
            ? Type.String({ title: 'Item', 'x-dataType': 'string' })
            : Type.Object(childDefinedPartialTypeDefinition, {
                title: 'Item',
                'x-dataType': 'object',
                additionalProperties: true,
              }),
          {
            'x-dataType': 'array',
            'x-propertyName': propertyName,
          },
        )
      : Type.Object(childDefinedPartialTypeDefinition, {
          'x-dataType': 'object',
          'x-propertyName': propertyName,
          additionalProperties: true,
        });

    //we know whatever partials the children defined, are nested in our property
    const partialTypeDefinition = {
      [propertyName]: propertySchema,
    };

    //And the given foreignKey exists on the parent object.
    return [childDefinedSubDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'listColumns',
  'NestedDetail',
  module.exports,
);
